import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import ADGMItemDetails from 'aurora-components/ADGMItemDetails/ADGMItemDetails';
import { keyEmptyCheck } from 'aurora-utils/utils';
import { ADGMPanel } from 'aurora-components';
import classNames from 'classnames';
import styles from './styles';

function PrimaryContactLessorInformation(props) {
  const { classes, primaryContact, locale } = props;
  return (
    <ADGMPanel title={keyEmptyCheck('primary_contact_details')} customClasses={{container: classes.marginTopOnSm }}>
      <Grid className={classNames(classes.accordionDetails, classes.boxPadding)}>
        <Grid container spacing={3} className={classNames(classes.occupantsGridsect, classes.boxBackground)}>
          <Grid item xs={12} md={4} className={classes.griditem2}>
            <Avatar alt='Primary contact' src='/images/avatar_profile.svg' className={classes.ownerAvatarimg} />

            <Grid>
              <Typography variant='body1' className={classes.lightWeightLable}>
                {keyEmptyCheck('Name')}
              </Typography>
              <Typography variant='subtitle1' className={classes.lightWeightValue}>
                {locale === 'ar' ? primaryContact?.nameAr : primaryContact?.nameEn}
              </Typography>
            </Grid>
          </Grid>

          <Grid item xs={12} md={2} className={classes.griditem}>
            <ADGMItemDetails
              label='Email'
              value={primaryContact?.email}
              labelClass={classes.lightWeightLable}
              valueClass={classes.lightWeightValue}
            />
          </Grid>
          <Grid item xs={12} md={2} className={classes.griditem}>
            <ADGMItemDetails
              label='phone_number'
              value={primaryContact?.mobile}
              labelClass={classes.lightWeightLable}
              valueClass={classes.lightWeightValue}
            />
          </Grid>
        </Grid>
      </Grid>
    </ADGMPanel>
  );
}

PrimaryContactLessorInformation.propTypes = {
  classes: PropTypes.object.isRequired,
  primaryContact: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
};

export default withStyles(styles)(PrimaryContactLessorInformation);
